export function additionalServicesInit() {
    const selectors = {
        main: '.b-additional-services',
        col: '.b-additional-services__col',
        wideCol: '.b-additional-services__col_wide',
        item: '.b-additional-services__item',
        mainContent: '.b-additional-services__main-content',
        hiddenContent: '.b-additional-services__hidden-content',
        toggleBtn: '.b-additional-services__toggle-btn',
        toggleBtnText: '.b-additional-services__toggle-btn-text',
    };
    
    const classes = {
        itemOpened: 'b-additional-services__item_opened',
    };
    
    $(selectors.main).each((index, elem) => {
        const $elem = $(elem);
        const elems = {
            $main: $elem,
            $cols: $elem.find(selectors.col).not(selectors.wideCol),
            $items: $elem.find(selectors.item),
            $mainContents: $elem.find(selectors.mainContent),
            $toggleBtns: $elem.find(selectors.toggleBtn),
            $window: $(window)
        };
    
        elems.$toggleBtns.on('click', onToggleBtnClickHandler);
    
        elems.$window.on('load', () => {
            setEqualMainContentsHeights();
        });
        
        elems.$window.resize(() => {
            setEqualMainContentsHeights();
        })
        
        function onToggleBtnClickHandler(e) {
            const $btn = $(e.currentTarget),
                $item = $btn.closest(selectors.item),
                isOpened = $item.hasClass(classes.itemOpened);
    
            $item.toggleClass(classes.itemOpened);
            $item.find(selectors.hiddenContent).stop(true, false).slideToggle(500);
    
            toggleBtnText($btn, isOpened);
        }
    
        function toggleBtnText($btn, isOpened) {
            let $btnText = $btn.find(selectors.toggleBtnText),
                btnTextWidth = $btnText.width(),
                btnTextAutoWidth;
            
            if (isOpened) {
                $btnText.width('auto');
                
                btnTextAutoWidth = $btnText.width();
                
                $btnText.width(0);
                $btnText.width(btnTextAutoWidth);
            } else {
                $btnText.width(btnTextWidth);
                $btnText.width(0);
            }
        }
        
        function setEqualMainContentsHeights() {
            elems.$mainContents.css('height', '');
            
            if (elems.$window.width() > 767) {
                const heightsArray = getMaxHeightsArray();
    
                heightsArray.forEach((height, index) => {
                    elems.$cols.find(`${selectors.item}:nth-child(${index + 1}) ${selectors.mainContent}`).height(height);
                })
            }
        }
        
        function getMaxHeightsArray() {
            let maxHeightsArray = [],
                mainContentHeight;
    
            elems.$cols.each((colIndex, col) => {
                $(col).find(selectors.item).each((itemIndex, item) => {
                    mainContentHeight = $(item).find(selectors.mainContent).height();
            
                    if (!maxHeightsArray[itemIndex] || mainContentHeight > maxHeightsArray[itemIndex]) {
                        maxHeightsArray[itemIndex] = mainContentHeight;
                    }
                })
            })
            
            return maxHeightsArray;
        }
    })
}
